import { useRef, useMemo } from 'react';
import Cookies from 'js-cookie';
import { useQuery } from '@tanstack/react-query';

import useEORedirectUrl from '~/domains/auth/hooks/useEORedirectUrl';
import { URLQueryKeys } from '~/domains/common/types/URLQueryKeys';
import { generateAndStoreSingleUseToken } from '~/services/identity/authenticated/identity.service.api';

import { useGetBranding } from './useGetBranding';

export function useEORedirect(enableSUTfetch: boolean) {
  const { getEORedirectUrl } = useEORedirectUrl();
  const { platform, destination } = useGetBranding();
  const hasRedirectedRef = useRef(false);

  const currentParams = new URLSearchParams(window.location.search);
  const redirectToEO = currentParams.get(URLQueryKeys.REDIRECT_TO_EO)
  const accessToken = Cookies.get('accessToken');
  const shouldRedirect = Boolean(accessToken && destination && redirectToEO);

  const { data: sutResponse } = useQuery({
    queryKey: ['generateAndStoreSingleUseToken'],
    queryFn: () => generateAndStoreSingleUseToken(),
    enabled: shouldRedirect && enableSUTfetch,
    cacheTime: 0, // Prevent caching
    staleTime: 0, // Always Stale
  });

  const eoRedirectUrl = useMemo(() => {
    if (hasRedirectedRef.current || !shouldRedirect || !sutResponse) return;

    const sut = sutResponse?.data?.token;
    if (sut) {
      const redirectUrl = getEORedirectUrl(destination, platform, sut);

      if (redirectUrl) {
        hasRedirectedRef.current = true;
        return redirectUrl;
      }
    }
  }, [shouldRedirect, sutResponse, destination, platform]);

  return { shouldRedirect, eoRedirectUrl };
}
